module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-meet-the-team virtual-smile"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), _c('Header'), (_vm.props) ? _c('div', {
    staticClass: "inner-page"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "left-area"
  }, [_c('div', {
    staticClass: "virtualsection1 feature-image"
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": _vm.props.acf.virtual_smile_section_1_image,
      "alt": ""
    }
  })]), _c('figcaption', [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.virtual_smile_section_1_title)
    }
  })])]), _c('div', {
    staticClass: "virtualsection2 block-intro"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "intro2",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.virtual_smile_section_2_intro)
    }
  })])]), _c('div', {
    staticClass: "virtualsection3"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.virtual_smile_section_3_title)
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.virtual_smile_section_3_intro)
    }
  })])]), _c('div', {
    staticClass: "virtualsection4"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.props.acf.virtual_smile_list) ? _c('div', {
    staticClass: "list-container"
  }, _vm._l((_vm.props.acf.virtual_smile_list), function(virtualsmile) {
    return _c('div', {
      staticClass: "list-virtual-item"
    }, [_c('div', {
      staticClass: "block-virtualsmile-imgg"
    }, [_c('img', {
      attrs: {
        "src": virtualsmile.image
      }
    })]), _c('div', {
      staticClass: "block-virtualsmile-text"
    }, [_c('h4', {
      domProps: {
        "innerHTML": _vm._s(virtualsmile.title)
      }
    }), _c('div', {
      staticClass: "intro",
      domProps: {
        "innerHTML": _vm._s(virtualsmile.description)
      }
    })])])
  })) : _vm._e()])])])])]) : _vm._e(), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94d50332","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/virtualsmile/virtualsmile.pug
// module id = 1298
// module chunks = 1